module.exports = __webpack_public_path__ + "static/heroslider1-52be8dba89ae3b73194314dfdc569953.jpg";